import React, { useEffect, useState } from 'react';

import { Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { map } from 'lodash';
import { DateRange } from 'react-day-picker/src/types/shared';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { customTheme } from 'theme';

import { AreaChart } from 'app/components/Visualization/Charts';
import { CustomDayPicker } from 'components/DataEntry/Date';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { customizedXAxisTick } from 'components/Visualization/Charts/utils';
import { yAxisTickWithPercent } from 'containers/Compliance/Components/ComplianceDashboard/styles';
import { selectBlueprints } from 'containers/PolicyHub/Blueprints/selectors';
import { actions } from 'containers/PolicyHub/Blueprints/slice';
import { formatDate } from 'utils/date';

export const PassPercentageByEnvironments = () => {
  const { passPercentageByEnvironments, blueprints } = useSelector(
    selectBlueprints,
  );
  const [selected, setSelected] = useState<DateRange>({
    to: new Date(),
    from: dayjs().subtract(30, 'days').toDate(),
  });
  const dispatch = useDispatch();
  const params = useParams<{ id: string }>();
  const [days, setDays] = useState<number>(30);

  useEffect(() => {
    const startDate = dayjs(selected?.from).format('YYYY-MM-DD');
    const endDate = dayjs(selected?.to).format('YYYY-MM-DD');
    dispatch(
      actions.getPassPercentageByEnvironment({
        q: { blueprintId: params?.id!, startDate, endDate },
      }),
    );
  }, [dispatch, params?.id, selected]);

  useEffect(() => {
    setDays(dayjs(selected?.to).diff(selected?.from ?? dayjs(), 'day'));
  }, [selected]);

  const data = map(passPercentageByEnvironments.data, (item, key: string) => ({
    name: formatDate(key, 'D-MMM-YY'),
    //'Passed Checks': item?.passed,
    passed: item?.passed,
    '% Passed': Number(
      (!!item?.total_performed && !!item?.passed
        ? item?.passed / item?.total_performed
        : 0) * 100,
    ).toFixed(0),
  }));

  return (
    <DashboardWidget
      label="Pass Percentage by Environments"
      subHeader={`Past ${days} days`}
      rightHeader={
        <CustomDayPicker
          dateProps={{
            mode: 'range',
            selected,
            onSelect: range => range && setSelected(range),
            disabled: { after: new Date() },
            navLayout: 'around',
          }}
          styles={{ inputBox: { w: 'auto', whiteSpace: 'nowrap' } }}
        />
      }
      content={
        <Box w="full" h="full" pl={2}>
          <AreaChart
            data={data}
            isLoading={
              passPercentageByEnvironments.isLoading || blueprints.isLoading
            }
            xField="name"
            yField={['% Passed']}
            colorMap={{ '% Passed': customTheme.colors.green['300'] }}
            legend={false}
            styles={{
              areaChart: { margin: { top: 12, bottom: -10 } },
              /*line: {
                dot: false,
              },*/
              yAxis: {
                domain: [0, 100],
                tickLine: false,
                axisLine: false,
                style: {
                  textAlign: 'left',
                },
                tick: props => yAxisTickWithPercent(props),
              },
              xAxis: {
                //tickLine: false,
                //interval: 'preserveStartEnd',
                interval: 1,
                padding: { right: 5, left: 5 },
                tick: props =>
                  customizedXAxisTick({ ...props, sliceLength: 10 }),
              },
            }}
          />
        </Box>
      }
      styles={{ contentWrapper: { pl: 1, pr: 0, pt: 0, pb: 1 } }}
    />
  );
};
